import React from 'react'

import PlaylistCard from 'app/VideoRepository/components/PlaylistCard'
import { useClickTracker } from 'utils/satu-event-tracker'

import type { Playlists as PlaylistsType } from 'types/video-inspirasi'

interface PlaylistsProps {
  playlists: PlaylistsType[]
  screenName?: string
  isDesktop?: boolean
}

const PlaylistsList = ({
  playlists,
  screenName,
  isDesktop,
}: PlaylistsProps) => {
  const trackClick = useClickTracker({
    activityType: 'CLICK_KONTEN_TAB_VIDEO_INSPIRASI',
    defaultAttributes: {
      screen_name: screenName,
    },
  })
  return (
    <div
      className={
        isDesktop
          ? 'grid grid-cols-2 xl:grid-cols-3 gap-6'
          : 'grid grid-cols-1 gap-3'
      }
    >
      {playlists.map(
        (
          { id, bannerImageUrl, name, videoCount, shortDescription, reviewer },
          index
        ) => (
          <PlaylistCard
            id={id}
            key={index}
            bannerImageUrl={bannerImageUrl}
            name={name}
            videoCount={videoCount}
            shortDescription={shortDescription}
            reviewer={reviewer}
            onClick={() => {
              trackClick({
                content_id: id,
              })
            }}
          />
        )
      )}
    </div>
  )
}

export default PlaylistsList
